.g3{border:1px solid #ddd;}